import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import MuiButton from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import React from "react";
import useDialogBackButton from "@/react/hooks/useDialogBackButton";
import { getPlatformCopyrightMessage, parseCopyrightMessage, } from "@/react/Webshop/copyrightMessage";
// A button rather than a link, as legacy webshop themes style a:link and
// would recolour the label to match the button.
const saveCopy = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = "";
    document.body.appendChild(link);
    link.click();
    link.remove();
};
const CopyrightDialog = ({ open, onClose, downloadUrl, message, }) => {
    const [t] = useTranslation();
    // Hardware/browser back closes the dialog instead of navigating away.
    useDialogBackButton(open, onClose);
    const { title, paragraphs } = parseCopyrightMessage(message || getPlatformCopyrightMessage(t));
    return (React.createElement(Dialog, { open: open, onClose: onClose, 
        // A portal's own text can be a few words, which would shrink the
        // dialog to fit them. Phones keep the paper's own 32px margins.
        slotProps: {
            paper: { sx: { minWidth: "min(400px, calc(100% - 64px))" } },
        } },
        React.createElement(DialogTitle, null, title),
        React.createElement(DialogContent, null, paragraphs.map((paragraph, index) => (React.createElement("p", { key: index }, paragraph)))),
        React.createElement(DialogActions, null, downloadUrl ? (React.createElement(React.Fragment, null,
            React.createElement(MuiButton, { onClick: onClose, color: "primary" }, t("Cancel")),
            React.createElement(MuiButton, { onClick: () => {
                    saveCopy(downloadUrl);
                    onClose();
                }, autoFocus: true, variant: "contained", color: "primary" }, t("Save low-res copy")))) : (React.createElement(MuiButton, { onClick: onClose, autoFocus: true, variant: "contained", color: "primary" }, t("I understand"))))));
};
export default CopyrightDialog;
